import React from 'react';
import classes from './styles.module.scss';

const Switch = ({ activeTab, handleClick, locations = ['Gaya', 'Patna'] }) => {
  return (
    <div className={classes.wrap}>
      {locations.map((location, index) => (
        <div
          key={location}
          className={classes.patna}
          style={{
            backgroundColor: index === activeTab ? '#AF2910' : 'white',
            color: index === activeTab ? 'white' : 'black',
            cursor: 'pointer'
          }}
          onClick={() => handleClick(index)}
        >
          {location}
        </div>
      ))}
    </div>
  );
};

export default Switch;
